import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from '../../lib/utils';

// shadcn/ui Tooltip (Radix), Lead Metrics' hover tips (Nic 2026-10-25). Same
// positioning engine as the Popover: it stays attached and inside the
// window (flips, slides, `collisionPadding`), renders in a portal so no
// table or card can clip or widen around it, opens on hover AND keyboard
// focus, closes on Escape, and is announced to screen readers. Pinned with
// the Popover (see package.json): newer Radix breaks CRA's Jest 27.

const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef(
  ({ className, sideOffset = 6, collisionPadding = 8, ...props }, ref) => (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        className={cn(
          'z-[1300] max-w-[min(16rem,var(--radix-tooltip-content-available-width))] rounded-md bg-slate-900 px-2 py-1 text-[11px] font-medium text-white shadow-lg',
          className,
        )}
        {...props}
      />
    </TooltipPrimitive.Portal>
  ),
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
